import { RouterView } from "vue-router";

export const deviceModelsRoute = {
  path: ":menu/device-models",
  component: <RouterView />,
  children: [
    {
      path: "",
      component: () => import("@/views/device-models/list/index.vue"),
    },
  ],
};
